export default __webpack_public_path__ + "static/media/financeDirector.c436543a.webp";